/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { useSelector } from "react-redux";

import { FileBlock } from "src/classes/block/block-types";
import { StandardFilePreview } from "src/components/Block/BlockTypes/FileBlock/StandardFilePreview";
import { StyledIframe } from "src/components/Block/BlockTypes/LinkBlock/styles";
import { AppState } from "src/store";

interface Props {
  block: FileBlock;
  disableMouse: boolean;
}
export function PDFBlock({ block, disableMouse }: Props) {
  const isScreenshotter = useSelector((state: AppState) => state.globalUI.uiSettings.isScreenshotter);
  return isScreenshotter ? (
    <StandardFilePreview block={block} />
  ) : (
    <StyledIframe src={block.pdfEmbedURL} allow-downloads={false} disableMouse={disableMouse} />
  );
}
